module.exports = __webpack_public_path__ + "static/c5-81c9acd2949e531fb1ad3256ceb5e975.png";